import React, { useState, useEffect, useRef } from "react";
import { Link, useParams, useLocation, useNavigate } from "react-router-dom";
import usePageTitle from 'hooks/usePageTitle';
import Moment from "moment";
import { Joyride } from 'react-joyride';
import { getJoyrideScrollOffset } from 'utils/joyrideConfig';
import { useRecordDetailTour } from 'hooks/useRecordDetailTour';
import PageMenu from "../../blocks/PageMenu/PageMenu";
import CardLinkIcon from "../../blocks/CardsLink/CardLinkIcon";
import Modal from "../../blocks/Modal/Modal";
import CommunicationsBlock from "../../blocks/CommunicationOpening/CommunicationOpening";
import CommunicationsGrid from "../../blocks/Grids/CommunicationsGrid";
import FormCreateCommunications from "../../blocks/Forms/FormCreateCommunication";
import { TextMessagesTemplates } from "../../blocks/TextMessagesTemplates/TextMessagesTemplates";
import useCreateUserCommunicationRecord from "../../../services/communications/useCreateUserCommunicationRecord";
import useGetUserChatCommunicationByIdRecord from "../../../services/communications/useGetUserChatCommunicationByIdRecord";
import useGetCompleteRecord from "../../../services/recordSheets/useGetCompleteRecord";
import useGetAllHealthcareInformation from "../../../services/recordSheets/useGetAllHealthcareInformation";
import useGetAllTransactionAvailableByContingencyType from "services/transaction/useGetAllTransactionAvailableByContingencyType";
import useModal from "../../../hooks/useModal";
import useCheckTypes from "../../../hooks/useCheckRecordStatusAndTypes";
import Icon from "../../blocks/Icon/Icon";
import IMGcheck from "../../../img/07.png";
import "./RecordDetail.scss";
import useGetAllHealthcareDocument from "services/record/useGetAllHealthcareDocument";
import useGetAllNonAssistanceDocuments from "services/record/useGetAllNonAssistanceDocuments";
import FormValidateOTP from "components/blocks/Forms/FormValidateOTP";
import HealthcareDocumentsCards from "components/blocks/Grids/HealthcareDocumentsCards";
import useGetRequestDocumentOtp from "services/record/useGetRequestDocumentOtp";
import useModals2 from "hooks/useModal2";
import LoaderMin from "components/blocks/Loader/LoaderMin";
import Loader from "components/blocks/Loader/Loader";
import GestionTabs from "components/blocks/ManagementItemBlock/GestionTabs";
import useGetAllAdministrationRecord from "services/recordSheets/useGetAllAdministrationRecord";
import useGetAllEconomicRecord from "services/recordSheets/useGetAllEconomicRecord";
import useDecode from "hooks/useDecode";
import useGetRole from "hooks/useGetRole";
import NoData from "../noData/NoData";
import RoyalDecreeFormsCards from "components/blocks/Grids/RoyalDecreeFormsCards";
import useGetRoyalDecreeForms from "hooks/useGetRoyalDecreeForms";
import FormPrestacionActiva from "components/blocks/ManagementNewForms/Inputs/FormPrestacionActiva";
import { useGeneralManagementState } from 'components/pages/GeneralManagement/generalManagementState';
import { EstadoRespuesta, ObtenerEncuestaResponse } from "@solimat/solimat-web-endpoint/lib/survey-ingestion/dto";

interface IvaluesFormReplyCommunication {
  subject: string;
  message: string;
  "loadfiles[]": any[];
}
interface IdataComunication {
  externalUserId: string;
  userId: string;
  prestacionId: string;
  asunto: string;
  mensaje: string;
  files: any[];
  comunicacionReferenciaId: null | string

}

const smoothScrollTo = (
  targetPosition: number,
  duration: number,
  onComplete?: () => void
) => {
  const startPosition = window.pageYOffset;
  const distance = targetPosition - startPosition;
  let startTime: number | null = null;

  const animation = (currentTime: number) => {
    if (startTime === null) startTime = currentTime;
    const timeElapsed = currentTime - startTime;
    // Clamp time to duration
    const nextTime = Math.min(timeElapsed, duration);
    const run = ease(nextTime, startPosition, distance, duration);

    window.scrollTo({
      top: run,
      behavior: 'instant' as ScrollBehavior
    });

    if (timeElapsed < duration) {
      requestAnimationFrame(animation);
    } else {
      if (onComplete) onComplete();
    }
  };

  const ease = (t: number, b: number, c: number, d: number) => {
    return c * t / d + b;
  };

  requestAnimationFrame(animation);
};

const RecordDetail: React.FC = () => {
  usePageTitle('Detalle Expediente');
  const { id: paramsId } = useParams<{ id: string }>();
  const location = useLocation();
  const navigate = useNavigate();
  const contingencyType = location.state?.contingencyType;
  const arrParamsId = (paramsId || '').split("_");
  const recordType = arrParamsId[0];
  const recordId = arrParamsId[1];
  const [documentID, setDocumentID] = useState<string>("");
  const [economicComponents, setEconomicComponents] = useState([]);
  const [administrativeComponents, setAdministrativeComponents] = useState([]);
  const tokenResponse = useDecode("token");
  const externalUserId = tokenResponse?.extension_external_id;

  const [highlightId, setHighlightId] = useState<string | null>(null);
  const { isImpersonation, isHisam } = useGetRole;

  const { run, tourKey, steps, handleCallback, startTour } = useRecordDetailTour();

  useEffect(() => {
    const handler = () => startTour();
    window.addEventListener('solimat:startRecordDetailTour', handler);
    return () => window.removeEventListener('solimat:startRecordDetailTour', handler);
  }, [startTour]);

  const JOYRIDE_PROPS = {
    continuous: true, scrollToFirstStep: true,
    locale: { back: 'Anterior', close: 'Cerrar', last: 'Finalizar', next: 'Siguiente', nextWithProgress: 'Siguiente ({current} de {total})', open: 'Iniciar tour de ayuda', skip: 'Omitir tour' },
    floaterProps: { offset: getJoyrideScrollOffset() },
    options: { primaryColor: '#0F1F3D', zIndex: 10000, overlayColor: 'rgba(15,47,73,0.45)', showProgress: true, buttons: ['back', 'skip', 'close', 'primary'] } as any,
    styles: { beaconInner: { backgroundColor: '#F97316' }, beaconOuter: { borderColor: '#F97316', backgroundColor: 'rgba(249,115,22,0.2)' }, tooltip: { borderRadius: 8, fontSize: 14 }, tooltipTitle: { fontSize: 15, fontWeight: 700, textAlign: 'left' as const }, tooltipContent: { textAlign: 'left' as const } },
  };

  const { state, dispatch } = useGeneralManagementState();

  const documentsRef = useRef<HTMLHeadingElement>(null);

  const {
    collapsed,
    handleOpenModal,
    handleCloseModal,
  } = useModal();
  const {
    collapsed2,
    handleOpenModal2,
    handleCloseModal2,
    handleDisableCloseButton2,
    disabledCloseButton2,
  } = useModals2();
  const {
    collapsed: collapsedForms,
    handleOpenModal: handleOpenModalForms,
    handleCloseModal: handleCloseModalForms,
  } = useModal();
  const {
    getAllTransactionAvailableByContingencyType,
  } = useGetAllTransactionAvailableByContingencyType();
  const {
    getCompleteRecordWithTd,
    getCompleteRecordWithoutTd,
    getCompleteRecordCata,
    getCompleteRecordOficio,
    errorCompleteRecord,
    record,
    userId,
  } = useGetCompleteRecord();
  const {
    getAllHealthcareInformation,
    loadingAllHealthcareInformation,
    dataAllHealthcareInformation,
  } = useGetAllHealthcareInformation();
  const {
    createUserCommunicationRecord,
    successCreateUserCommunicationRecord,
    loadingCreateUserCommunicationRecord,
    errorCreateUserCommunicationRecord,
  } = useCreateUserCommunicationRecord();
  const {
    errorGetUserChatCommunicationRecord,
    getUserChatCommunicationByIdRecord,
    loadingGetUserChatCommunicationRecord,
    userChatCommunicationRecord,
    isComunicacionHabilitada
  } = useGetUserChatCommunicationByIdRecord();
  const {
    allNonAssistanceDocuments,
    getAllNonAssistanceDocuments,
    loadingGetAllNonAssistanceDocuments,
  } = useGetAllNonAssistanceDocuments();
  const { allHealthcareDocuments, getAllHealthcareDocument } =
    useGetAllHealthcareDocument();

  const { getRequestDocumentOtp, errorGetRequestDocumentOtp } =
    useGetRequestDocumentOtp();
  const { getAllAdministrationRecord } =
    useGetAllAdministrationRecord();
  const { getAllEconomicRecord } =
    useGetAllEconomicRecord();
  const { checkContingencyType } = useCheckTypes();
  const { getRoyalDecreeForms, royalDecreeForms } = useGetRoyalDecreeForms()

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const scrollTo = queryParams.get("scrollTo");

    if (scrollTo === "generalDocuments" && documentsRef.current && !loadingAllHealthcareInformation && !loadingGetAllNonAssistanceDocuments && record) {
      setTimeout(() => {
        if (documentsRef.current) {
          const headerOffset = 180;
          const elementPosition = documentsRef.current.getBoundingClientRect().top;
          const currentPosition = window.pageYOffset;
          const offsetPosition = elementPosition + currentPosition - headerOffset;

          const distance = Math.abs(offsetPosition - currentPosition);

          // Speed: 1.0px/ms (Faster)
          const speedPxPerMs = 1.0;
          const calculatedDuration = Math.max(500, distance / speedPxPerMs);

          const queryParams = new URLSearchParams(location.search);
          const hId = queryParams.get("highlightId");

          smoothScrollTo(offsetPosition, calculatedDuration, () => {
            if (hId) {
              setHighlightId(hId);
            }
          });
        }
      }, 100);
    }
  }, [location, loadingAllHealthcareInformation, loadingGetAllNonAssistanceDocuments, record]);


  const getContingencyIcon = (contingencia: number): string => {
    switch (contingencia) {
      case 1: return "activity";       // Enfermedad Común — pulso médico
      case 4: return "alert-triangle"; // Accidente Laboral Con Baja — peligro
      case 7: return "alert-triangle"; // Accidente Laboral Sin Baja — peligro
      case 8: return "heart";          // Riesgo durante embarazo — cuidado maternal
      case 14: return "users";          // Cuidado hijos — familia
      case 18: return "briefcase";      // Cese actividad autónomos — actividad laboral
      case 24: return "shield";         // Situación asimilada AT — protección legal
      case 25: return "euro";           // Prestación extraordinaria cese — prestación económica
      default: return "info";           // Sin Determinar / otros
    }
  };

  const [collapsedMessage, setCollapsedMessage] = useState(true);

  const handleOpenModalMessage = async () => {
    setCollapsedMessage(false);
  };
  const handleCloseModalMessage = () => {
    setCollapsedMessage(true);
    handleGetCompleteRecord();
    getUserChatCommunicationByIdRecord(userId, recordId);
  };

  const checkTotalEpisodes = (
    episodes: any[] | undefined,
    episodeType: number
  ) => {
    let result = episodes?.filter(
      (episode) => episode.tipoComponente === episodeType
    );
    if (result && result.length > 0) {
      return result[0].contador;
    }
    return 0;
  };
  const convertBase64 = async (files: any) => {
    if (!files || files.length === 0) return [];
    var arrayAuxiliar: any = [];
    if (files) {
      Array.from(files).forEach((file: any) => {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
          let prevExtension = file.name.split(".");
          var base64I = reader.result as string;
          arrayAuxiliar.push({
            name: file.name,
            extension: prevExtension.pop(),
            externalUri: "",
            base64: base64I.split(",")[1],
            externalId: "",
          });
        };
      });
    }
    return arrayAuxiliar;
  };
  const onSubmitCommunication = async (values: any) => {
    const dataFiles = await convertBase64(values.files || []);
    //send communication
    setTimeout(() => {
      const newDataJsonRecord: IdataComunication = {
        externalUserId: externalUserId,
        userId: userId,
        prestacionId: recordId,
        asunto: values.asunto,
        mensaje: values.mensaje,
        files: dataFiles && dataFiles,
        comunicacionReferenciaId: null
      };

      createUserCommunicationRecord(userId, recordId, newDataJsonRecord);
      handleCloseModal();
    }, 700);

  };
  useEffect(() => {
    getUserChatCommunicationByIdRecord(userId, recordId);
    getAllEconomicRecord(userId, recordId, setEconomicComponents);
    getAllAdministrationRecord(userId, recordId, setAdministrativeComponents);
    getRoyalDecreeForms(userId, recordId)
  }, []);

  useEffect(() => {
    if (
      (successCreateUserCommunicationRecord &&
        !errorCreateUserCommunicationRecord) ||
      (!successCreateUserCommunicationRecord &&
        errorCreateUserCommunicationRecord)
    ) {
      handleCloseModal();
      handleOpenModalMessage();
      getUserChatCommunicationByIdRecord(userId, recordId);
    }
  }, [
    successCreateUserCommunicationRecord,
    errorCreateUserCommunicationRecord,
  ]);

  useEffect(() => {
    if (recordType) {
      handleGetCompleteRecord();
      getAllNonAssistanceDocuments(userId, recordId);
      if (!isImpersonation() || isHisam()) {
        getAllHealthcareDocument(userId, recordId);
      }
    }
    Moment().locale("es").format("DD/MM/YYYY");
  }, [recordId]);

  const getCompleteRecord = (recordType: string) => {
    switch (recordType) {
      case "1":
        return getCompleteRecordWithTd(userId, recordId);
      case "2":
        return getCompleteRecordWithoutTd(userId, recordId);
      case "3":
        return getCompleteRecordCata(userId, recordId);
      case "4":
        return getCompleteRecordOficio(userId, recordId);
    }
  };

  const handleGetCompleteRecord = () => {
    getCompleteRecord(recordType);
    if (!isImpersonation() || isHisam()) {
      getAllHealthcareInformation(userId, recordId);
    }
    if (contingencyType) {
      getAllTransactionAvailableByContingencyType(recordType, contingencyType);
    }
  };

  useEffect(() => {
    if (record) {
      if (contingencyType === undefined) {
        getAllTransactionAvailableByContingencyType(
          recordType,
          record.contingency_type
        );
      }

      if (record.ExpedienteId && record.ExpedienteId !== null) {
        let encuestaTemp = state.surveys?.find((s: ObtenerEncuestaResponse) => s.expedienteId === record.ExpedienteId
          && (s.estadoRespuesta === EstadoRespuesta.Vacia || s.estadoRespuesta === EstadoRespuesta.Rellena)
          && !s.caducada) ?? null;

        if (encuestaTemp) {
          dispatch({
            type: "SHOW_SURVEY",
            payload: { show: true, id: encuestaTemp.asignacionId }
          });
        }
      }
    }
  }, [record]);

  const handleRedirect = (pathTo: string, args: any) => {
    if (args != null && args.type != null && args.type_id != null) {
      if (args.type && typeof args.type_id === "number") {
        window.localStorage.setItem("typeEpisode", args.type);
        window.localStorage.setItem("typeId", args.type_id);
        let redirectPath = `/historial/${recordType}_${recordId}_${record.contingencia}/${pathTo}?tipo-componente=${args.type_id}`;
        navigate(redirectPath, {
          state: {
            record: record,
            allHealthcareDocuments: allHealthcareDocuments,
            filter: {
              type: args.type,
              type_id: args.type_id,
            },
          }
        });
      }
    } else {
      let redirectPath = `/historial/${recordType}_${recordId}/${pathTo}`;
      navigate(redirectPath, {
        state: {
          record: record,
          filter: {
            type: args.type,
          },
        }
      });
    }
  };
  const handleRequestDocument = (documentID: string) => {
    setDocumentID(documentID);
    handleOpenModal2();
    getRequestDocumentOtp(userId, recordId, documentID);
  };

  return (
    <>
      <Joyride key={tourKey} steps={steps} run={run} onEvent={handleCallback} {...JOYRIDE_PROPS} />
      {loadingAllHealthcareInformation || record === null ? (
        <section>
          {(loadingAllHealthcareInformation || record === null) && !errorCompleteRecord && (
            <Loader activeLoader label="Cargando prestación" />
          )}
          {errorCompleteRecord && TextMessagesTemplates.errorResponse}
        </section>
      ) : (
        <>
          <div className="rd-hero">
            <div className="container">
              <div className="rd-hero__nav">
                <nav className="rd-hero__breadcrumbs" aria-label="breadcrumb">
                  <Link to="/inicio" className="rd-hero__breadcrumb-link">Inicio</Link>
                  <span className="rd-hero__breadcrumb-sep">›</span>
                  <Link to="/historial" className="rd-hero__breadcrumb-link">Historial</Link>
                  <span className="rd-hero__breadcrumb-sep">›</span>
                  <span className="rd-hero__breadcrumb-current">{checkContingencyType(parseInt(record.contingencia))}</span>
                </nav>
                <Link to="/historial" className="rd-hero__back">
                  <Icon name="arrow-left" size={13} />
                  Volver al historial
                </Link>
              </div>

              <div className="rd-hero__card">
                <div className="rd-hero__card-body">
                  {record?.codigoExpediente && (
                    <div className="rd-hero__exp">EXP · {record.codigoExpediente}</div>
                  )}
                  <h1 className="rd-hero__title">{checkContingencyType(parseInt(record.contingencia))}</h1>
                  {record?.tieneExtincion ? (
                    <div className="rd-hero__extinct"><strong>{record.descripcionExtincion}</strong></div>
                  ) : (
                    <div className="rd-hero__dates">
                      {record?.fechaInicio && (
                        <span className="rd-hero__date-pill">
                          <Icon name="calendar" size={12} />
                          Inicio · {Moment(record.fechaInicio).format("DD/MM/YYYY")}
                        </span>
                      )}
                      {record?.fechaFin && (
                        <span className="rd-hero__date-pill">
                          Fin · {Moment(record.fechaFin).format("DD/MM/YYYY")}
                        </span>
                      )}
                    </div>
                  )}
                </div>
                <div className="rd-hero__icon">
                  <Icon name={getContingencyIcon(parseInt(record.contingencia))} size={72} strokeWidth={1} />
                </div>
              </div>
            </div>
          </div>
          <div className="container">
            <div className="row">
              <div className="col-12">
                {/*   <div className="box-info-block">
                  {record?.tieneExtincion ? (
                    <div className="record-extinct">
                      <h4 className="description-extincion">{record && record.descripcionExtincion}</h4>
                      <p className="num-expediente">Expediente: {record?.codigoExpediente}</p>
                    </div>
                  ) : (
                    <>
                      <p>Expediente: {record?.codigoExpediente}</p>
                      <p>
                        Fecha Inicio:{" "}
                        {record?.fechaInicio &&
                          `${Moment(record?.fechaInicio).format("DD/MM/YYYY")}`}
                      </p>
                      <p>
                        Fecha Fin:{" "}
                        {record?.fechaFin &&
                          `${Moment(record?.fechaFin).format("DD/MM/YYYY")}`}
                      </p>
                    </>
                  )}
                </div> */}
              </div>
            </div>
            {(!isImpersonation() || isHisam()) &&
              <section className="row">
                <div className="col-12">
                  <div className="rd-section-head mt-4">
                    <h2 className="rd-section-head__title">Información asistencial</h2>
                    <p className="rd-section-head__sub">Accede a las distintas áreas de tu proceso asistencial.</p>
                  </div>
                  <div className="row">
                    <div className="col-lg-4">
                      <CardLinkIcon
                        iconType={`consultation`}
                        title={`Consultas`}
                        numberSessions={checkTotalEpisodes(
                          dataAllHealthcareInformation,
                          200
                        )}
                        typeSessions={`Consultas`}
                        handlerRedirect={handleRedirect}
                        params={{
                          type: "Consultas",
                          type_id: 200,
                        }}
                        pathTo="informacion-asistencial"
                      />
                    </div>
                    <div className="col-lg-4">
                      <CardLinkIcon
                        iconType={`rehab`}
                        title={`Rehabilitación`}
                        numberSessions={checkTotalEpisodes(
                          dataAllHealthcareInformation,
                          205
                        )}
                        typeSessions={`Sesiones`}
                        handlerRedirect={handleRedirect}
                        params={{
                          type: "Rehabilitación",
                          type_id: 205,
                        }}
                        pathTo="informacion-asistencial"
                      />
                    </div>
                    <div className="col-lg-4">
                      <CardLinkIcon
                        iconType={`operation`}
                        title={`Quirófano`}
                        numberSessions={checkTotalEpisodes(
                          dataAllHealthcareInformation,
                          204
                        )}
                        typeSessions={`Operaciónes`}
                        handlerRedirect={handleRedirect}
                        params={{
                          type: "Quirófano",
                          type_id: 204,
                        }}
                        pathTo="informacion-asistencial"
                      />
                    </div>
                    <div className="col-lg-4">
                      <CardLinkIcon
                        iconType={`hospitalization`}
                        title={`Hospitalización`}
                        numberSessions={checkTotalEpisodes(
                          dataAllHealthcareInformation,
                          202
                        )}
                        typeSessions={`Hospitalizaciónes`}
                        handlerRedirect={handleRedirect}
                        params={{
                          type: "Hospitalización",
                          type_id: 202,
                        }}
                        pathTo="informacion-asistencial"
                      />
                    </div>
                    <div className="col-lg-4">
                      <CardLinkIcon
                        iconType={`emergencies`}
                        title={`Urgencias`}
                        numberSessions={checkTotalEpisodes(
                          dataAllHealthcareInformation,
                          206
                        )}
                        typeSessions={`Urgencias`}
                        handlerRedirect={handleRedirect}
                        params={{
                          type: "Urgencias",
                          type_id: 206,
                        }}
                        pathTo="informacion-asistencial"
                      />
                    </div>
                    <div className="col-lg-4">
                      <CardLinkIcon
                        loading={true}
                        iconType={`documentation`}
                        title={`Documentación`}
                        healthcareDocuments={
                          allHealthcareDocuments !== null
                            ? allHealthcareDocuments.length
                            : 0
                        }
                        handlerRedirect={handleRedirect}
                        params={{
                          type: "Documentación asistencial",
                          type_id: 207,
                        }}
                        pathTo="informacion-asistencial"
                      />
                    </div>
                    <div className="col-lg-4">
                      <CardLinkIcon
                        iconType={`image`}
                        title={`Imagen`}
                        numberSessions={checkTotalEpisodes(
                          dataAllHealthcareInformation,
                          203
                        )}
                        typeSessions={`Imagen`}
                        handlerRedirect={handleRedirect}
                        params={{
                          type: "Imagen",
                          type_id: 203,
                        }}
                        pathTo="informacion-asistencial"
                      />
                    </div>
                  </div>
                </div>
              </section>
            }
            <section className="row">
              <div className="col-12">
                <div className="rd-section-head">
                  <h2 className="rd-section-head__title">Gestión</h2>
                  <p className="rd-section-head__sub">Administración, gestión económica y jurídica de tu prestación.</p>
                </div>
                <GestionTabs
                  administrativeData={administrativeComponents}
                  economicData={economicComponents ?? []}
                />
              </div>
            </section>
            {
              (
                !record?.fechaFin ||
                (Array.isArray(royalDecreeForms) && royalDecreeForms.length > 0)
              ) && (
                <section className="row">
                  <div className="col-12">

                    <div className="d-flex justify-content-between align-items-center">
                      <div className="rd-section-head my-2" data-tour="rd-formularios">
                        <h2 className="rd-section-head__title">Formularios</h2>
                        <p className="rd-section-head__sub">Formularios activos relacionados con tu prestación.</p>
                      </div>

                      {!record?.fechaFin && !record?.tieneExtincion && (
                        <div className="btns-upon-box-container align-items-center my-2" data-tour="rd-formularios-add">
                          <button
                            className="btn-box btn-outline-accent"
                            onClick={handleOpenModalForms}
                          >
                            <span className="e-icons e-add-new"></span>
                            <span>Agregar formulario</span>
                          </button>
                        </div>
                      )}
                    </div>


                    {Array.isArray(royalDecreeForms) && royalDecreeForms.length > 0
                      ? <RoyalDecreeFormsCards arrData2={royalDecreeForms} />
                      : <NoData message="No hay formularios para mostrar." />
                    }

                  </div>
                </section>
              )
            }
            <section className="row">
              <div className="col-12">
                <div className="rd-section-head" ref={documentsRef} data-tour="rd-documentacion">
                  <h2 className="rd-section-head__title">Documentación General</h2>
                  <p className="rd-section-head__sub">Documentos y archivos asociados a tu prestación.</p>
                </div>
                {loadingGetAllNonAssistanceDocuments
                  ? TextMessagesTemplates.loading
                  : ""}
                {allNonAssistanceDocuments?.length ? (
                  <HealthcareDocumentsCards
                    handleRequestDocument={handleRequestDocument}
                    highlightId={highlightId}
                    documents={allNonAssistanceDocuments.map((doc: any) => ({
                      nombre: doc.nombre,
                      extension: doc.extension,
                      company: doc.company ?? "-",
                      fecha: doc.fecha,
                      id: doc.id,
                      requiereOtp: doc.requiereOtp,
                      uri: doc.uri,
                    }))}
                  />
                ) : (
                  <NoData message={'No hay documentos para mostrar.'} />
                )}
              </div>
              <Modal
                disabledCloseButton={disabledCloseButton2}
                collapsed={collapsed2}
                onClose={handleCloseModal2}
                title={"Introduzca el código"}
                subtitle={
                  "Para visualizar el documento, introduzca el código que hemos enviado a su teléfono"
                }
              >
                {collapsed2 ? (
                  <div className="ghost-form"></div>
                ) : (
                  <>
                    {documentID ? (
                      <FormValidateOTP
                        handleDisableCloseButton={handleDisableCloseButton2}
                        onClose={handleCloseModal2}
                        documentID={documentID}
                        userId={userId}
                        prestacionId={recordId}
                      />
                    ) : (
                      <>
                        {errorGetRequestDocumentOtp ? (
                          <div>
                            <h3 className="modal_title">Error</h3>
                            <p className="c-center">
                              Lo sentimos, se ha producido un error
                            </p>
                          </div>
                        ) : (

                          <LoaderMin />
                        )}
                      </>
                    )}
                  </>
                )}
              </Modal>
            </section>
            {userChatCommunicationRecord && userChatCommunicationRecord ? (
              <section className="row">

                <div className="col-12">
                  <div className="d-flex justify-content-between align-items-center">

                    <div className="rd-section-head mb-0" data-tour="rd-comentarios">
                      <h2 className="rd-section-head__title">Comentarios</h2>
                      <p className="rd-section-head__sub">Historial de comunicaciones y comentarios.</p>
                    </div>

                    {userChatCommunicationRecord && isComunicacionHabilitada && (
                      <button className="btn-box btn-outline-accent" onClick={handleOpenModal}>
                        <span className="e-icons e-add-new"></span>
                        <span>Nuevo comentario / documento</span>
                      </button>
                    )}

                  </div>
                </div>

                <>
                  {loadingGetUserChatCommunicationRecord ||
                    errorGetUserChatCommunicationRecord ? (
                    <section>
                      {loadingGetUserChatCommunicationRecord &&
                        TextMessagesTemplates.loading}
                      {errorGetUserChatCommunicationRecord &&
                        TextMessagesTemplates.errorResponse}
                    </section>
                  ) : (
                    ""
                  )}

                  {userChatCommunicationRecord?.length > 0 ? (
                    <div className="col-12">
                      <div className="record-detail__communications-grid">
                        <CommunicationsGrid
                          arrData={userChatCommunicationRecord}
                          recordType={recordType}
                        />
                      </div>
                    </div>
                  ) : (
                    <div className="col-12">
                      <NoData message="No hay comentarios para mostrar." />
                    </div>
                  )}
                </>

                {!collapsed && !isImpersonation() && (
                  <FormCreateCommunications
                    title={"Crear comunicación"}
                    onSubmit={onSubmitCommunication}
                    onClose={handleCloseModal}
                    loadingProcess={loadingCreateUserCommunicationRecord}
                  />
                )}

                <Modal
                  collapsed={collapsedMessage}
                  onClose={handleCloseModalMessage}
                >
                  <div className="confirm-message">
                    <div className="img-container">
                      <img src={IMGcheck} alt="" />
                    </div>
                    <p style={{ color: '#fff' }}>
                      {successCreateUserCommunicationRecord
                        ? "Mensaje enviado. En breve podrá verlo en el listado"
                        : "Lo sentimos, se ha producido un error, inténtelo de nuevo más tarde."}
                    </p>
                    <div className="btn-resolve-container">
                      <button
                        className="btn-box btn-accent"
                        onClick={handleCloseModalMessage}
                      >
                        Entendido
                      </button>
                    </div>
                  </div>
                </Modal>

              </section>
            ) : !loadingGetUserChatCommunicationRecord ? (
              <section className="row">
                <div className="col-12">
                  <div className="rd-section-head mb-0" data-tour="rd-comentarios">
                    <h2 className="rd-section-head__title">Comentarios</h2>
                    <p className="rd-section-head__sub">Historial de comunicaciones y comentarios.</p>
                  </div>
                  <NoData message="No hay comentarios para mostrar." />
                </div>
              </section>
            ) : null}
            <section>
              <Modal light fullHeight maxWidth="1200px" collapsed={collapsedForms} onClose={handleCloseModalForms} title="Formularios activos" subtitle="Aquí se le mostrarán los formularios relacionados con la prestación activa">
                <FormPrestacionActiva expedienteId={record.ExpedienteId ?? null} />
              </Modal>
            </section>
          </div>
        </>
      )}
    </>
  );
};

export default RecordDetail;
